import ServerDirections from "../config/server-directions";
import errorManager from "./error.manager";
import store from "../store";

export class AuthService {
  constructor() {
    this.login = this.login.bind(this);
    this.logout = this.logout.bind(this);
  }

  login(context, credentials) {
    return new Promise((resolve, reject) => {
      context.$http
        .post(ServerDirections.LOGIN, credentials.toJSON(), {
          params: { instanceId: store.getters.instanceId },
        })
        .then(
          (data) => {
            context.$store.dispatch("logIn", {
              router: context.$router,
              token: data.body.token,
            });
            resolve(data.body);
          },
          (error) => {
            errorManager.manageError(context, error);
            reject(error);
          }
        );
    });
  }
  signUp(context, signUpData) {
    return new Promise((resolve, reject) => {
      context.$http
        .post(ServerDirections.USERS, signUpData.toJSON(), {
          params: { instanceId: store.getters.instanceId },
        })
        .then(
          (data) => {
            resolve(data.body);
          },
          (error) => {
            errorManager.manageError(context, error);
            reject(error);
          }
        );
    });
  }

  recover(context, email) {
    return new Promise((resolve, reject) => {
      context.$http
        .get(ServerDirections.PASSWORD, {
          params: {
            instanceId: store.getters.instanceId,
            email: email,
          },
        })
        .then(
          (data) => {
            resolve(data.body);
          },
          (error) => {
            errorManager.manageError(context, error);
            reject(error);
          }
        );
    });
  }

  changePassword(context, credentials) {
    return new Promise((resolve, reject) => {
      context.$http.put(ServerDirections.PASSWORD, credentials).then(
        (data) => {
          context.$store.dispatch("logIn", {
            router: context.$router,
            token: data.body.token,
          });
          resolve(data.body);
        },
        (error) => {
          errorManager.manageError(context, error);
          reject(error);
        }
      );
    });
  }

  setPassword(context, credentials) {
    return new Promise((resolve, reject) => {
      context.$http.put(ServerDirections.USERS, credentials).then(
        (data) => {
          context.$store.dispatch("logIn", {
            router: context.$router,
            token: data.body.token,
          });
          resolve(data.body);
        },
        (error) => {
          errorManager.manageError(context, error);
          reject(error);
        }
      );
    });
  }

  logout(context) {
    context.$store.dispatch("logOut", context.$router);
  }
}
